import Icon from '@/components/ui/AppIcon';

interface Feature {
  icon: string;
  title: string;
  description: string;
}

const FeaturesSection = () => {
  const features: Feature[] = [
    {
      icon: "SparklesIcon",
      title: "Personalized Plans",
      description: "Receive customized wellness recommendations based on your lifestyle, goals, and preferences."
    },
    {
      icon: "ClockIcon",
      title: "Time-Efficient",
      description: "Get practical routines that fit your schedule, from 15-minute activities to comprehensive plans."
    },
    {
      icon: "ChatBubbleBottomCenterTextIcon",
      title: "Conversational AI",
      description: "Engage in natural, supportive conversations that adapt to your unique wellness journey."
    },
    {
      icon: "UserGroupIcon",
      title: "Cultural Adaptation",
      description: "Recommendations that respect and incorporate your cultural food habits and preferences."
    },
    {
      icon: "LightBulbIcon",
      title: "Holistic Approach",
      description: "Balanced guidance covering movement, meditation, nutrition, and sustainable lifestyle changes."
    },
    {
      icon: "ShieldCheckIcon",
      title: "Privacy First",
      description: "Session-based conversations with no permanent data storage. Your privacy is our priority."
    }
  ];

  return (
    <section className="py-16 md:py-24 px-4 bg-surface">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-text-primary mb-4">
            Why Choose <span className="text-primary">LivsmartCoach</span>?
          </h2>
          <p className="text-lg text-text-secondary max-w-2xl mx-auto">
            Experience wellness coaching that adapts to you, not the other way around.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-card p-6 md:p-8 rounded-lg border border-border shadow-soft hover:shadow-soft-md transition-smooth"
            >
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
                <Icon name={feature.icon as any} size={24} className="text-primary" />
              </div>
              <h3 className="text-xl font-semibold text-card-foreground mb-3">
                {feature.title}
              </h3>
              <p className="text-text-secondary leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;